import api from './api';

/**
 * Create a tracking function configured with a particular "view" and "section".
 * Returned function accepts params for "identifier" and "extra_content", for
 * tracking individual events.
 *
 * @return  {Function}  function for tracking events
 */
export default (view, section) => {
  return (identifier = null, extra_content, type_id) => {
    const page = window.location.pathname;

    return api.track({
      identifier,
      page,
      view,
      section,
      type_id,
      extra_content,
    });
  }
}

export const createRecitTracker = (action, cxt_view, type_id) => {
  return (
      cxt_model,
      time,
      cxt_rec_id,
      cxt_page_load_id,
      cxt_synd_id,
      cxt_module,
      cxt_position,
      cxt_rec_item_id,
  ) => {
    api.track({
      action,
      time,
      cxt_view,
      cxt_model,
      cxt_rec_id,
      cxt_page_load_id,
      cxt_synd_id,
      cxt_module,
      cxt_position,
      cxt_rec_item_id,
      type_id,
    });
  }
}
